import {
  prop,
  pathOr,
} from 'ramda'
import {
  getCustomersTaxonomies,
} from '../../services/apis'
import {
  isServerResponseError,
  hasError,
} from '../common'

const getTaxonomies = async (page, limit, search, searchIn, parent_name) => {
  const result = await getCustomersTaxonomies({
    page,
    limit,
    search,
    searchIn,
    parent_name
  })
  return isServerResponseError(result) || hasError(result)
    ? {
      total: 0,
      data: []
    }
    : {
      total: pathOr([], ['data', 'total'], result),
      data: pathOr([], ['data', 'data'], result),
    }
}

export default getTaxonomies
